export const viewTitle = "Настройка профиля";
export const viewUniqKey = "profile";
